<h2>Physical Attributes<button class="icon--history btn--default" type="button" (click)="showHistory(customerNumber)" *ngIf="viewHistory">View History</button></h2>
<p-table #dt [value]="attributes" styleClass="p-datatable-striped">
    <ng-template pTemplate="header">
        <tr>
            <th>Gender</th>
            <th>Eye Color</th>
            <th>Hair Color</th>
            <th>Height</th>
            <th>Weight</th>
            <th class="w--icon" *ngIf="canEdit">Edit</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptyMessage">
        <tr>
            <td [attr.colspan]="5 + (!!canEdit ? 1 : 0)">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
        <tr [pSelectableRow]="rowData">          
            <td>{{rowData.isBiometricRedacted ? '******' : rowData.gender}}</td>
            <td>{{rowData.isBiometricRedacted ? '******' : rowData.eyeColor}}</td>
            <td>{{rowData.isBiometricRedacted ? '******' : rowData.hairColor}}</td>
            <td>{{rowData.isBiometricRedacted ? '******' : rowData.displayHeight}}</td>
            <td>{{rowData.isBiometricRedacted ? '******' : rowData.displayWeight}}</td>
            <td class="text-center" *ngIf="canEdit"> <a [ngClass]="{'disabled': rowData.isBiometricRedacted}" class="icon--edit" title="Edit Attribute" href="javascript:void(0);" (click)="editAttribute(rowData.id)"></a></td>
        </tr>
    </ng-template>
</p-table>